import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardHeader,
  Input,
  Container,
  Button,
  Table,
  Row,
} from "reactstrap";

// import "views/pages/manage/addressType/node_modules/react-sliding-pane/dist/react-sliding-pane.css";
import { failureToast, successToast } from "../../../common/utils/methods/toasterFunctions/function";
import { MasterHeaderAuto } from "../../../common/commonComponents/masterHeader/masterHeader";
import { NewRow, checkPermission } from "../../../common/utils/methods/commonMethods/utilityMethod";
import {
  getAPI,
  masterServiceBaseUrl,
  putpost,
  putpost2,
} from "services/http";
import { RolePermissions } from 'appContext'
import { PermissionContext } from 'appContext'
import { pages } from "views/pages/manage/common/constant";
import StatusCellComponent from '../room/StatusCellComponent.jsx'

import { ToExcel } from "../../../common/commonComponents";

// const excelDetails = {
//   "Business Group": "Business Group",
//   "Company Code": "Company Code",
//   Zone: "Zone",
//   Region: "Region",
//   "Business Area": "Business Area",
//   "Building Name": "Building Name",
//   Address: "Building Address",
//   City: "City",
//   State: "State",
//   Country: "Country",
//   Pincode: "Pincode",
//   "Floor Name": "floorName",
//   "Floor Code": "floorCode",
//   "Floor Status": "status",
// };

const excelDetails = {
  Region: "Region",
  "Business Area": "Business Area",
  "Building Name": "Building Name",
  Address: "Building Address",
  City: "City",
  State: "State",
  Country: "Country",
  Pincode: "Pincode",
  "Floor Name": "floorName",
  "Floor Code": "floorCode",
  "Floor Status": "status",
};
var _ = require("lodash");

const FloorTable = (props) => {
  const {
    serverData,
    setSearch,
    resetSearch,
    isSaveVisible,
    setisSaveVisible,
    action,
    buildingMasterId,
    setHeaderDataForRoom = () => {},
    buildingHeraderData,
  } = props;
  const userPermissions = RolePermissions(useContext(PermissionContext), pages['buildingmaster']['id']);

  const [tableDataKey, settableDataKey] = useState("tableDataKey");
  const [updatedKey, setUpdateKey] = useState(new Date());
  const [searchStr, setSearchStr] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const addNewClass = () => {
    props.setclassArray([
      {
        editMode: true,
        __status: "__new",
        status: "ACTIVE",
        floorName: "",
        floorCode: "",
      },
      ...props.classArray,
    ]);
  };

  const headerList = [
    { name: "Floor Name", isRequired: true },
    { name: "Floor Code", isRequired: true },
    { name: "Status", isRequired: true },
    { name: "Add/View Room" },
    { name: "Actions" },
  ];

  const listToRender = ["floorName", "floorCode", "status"];

  const saveAll = (cb) => {
    var _tempArray = props.classArray;
    var isValid = true;
    _tempArray.forEach((el, index) => {
      if (el["editMode"]) {
        if (!el["floorName"] || !el["floorName"].trim()) {
          isValid = false;
          failureToast("Please Enter Floor Name");
          return;
        }
        // else if (
        //   !el['floorShortDesc'] ||
        //   !el['floorShortDesc'].trim()
        // ) {
        //   isValid = false;
        //   failureToast('Please Enter Short Description');
        //   return;
        // }
        else if (!el["floorCode"] || !el["floorCode"].trim()) {
          isValid = false;
          failureToast("Please Enter Floor Code");
          return;
        }
        if (!isValid) {
          return;
        }
        if (_tempArray[index]["__status"] == "__new") {
          putpost(
            masterServiceBaseUrl + "/floorMaster/createFloorMaster",
            (data) => {
              successToast(data["message"]);
              setisSaveVisible(false);
              setUpdateKey(new Date());
              props.fetchClasses(
                `${masterServiceBaseUrl}/floorMaster/getFloorMasterByBuildingMasterId/${buildingMasterId}`
              );
            },
            (data) => {
              failureToast(data["message"]);
            },
            { ..._tempArray[index], buildingMasterId: buildingMasterId },
            "post"
          );
        } else {
          putpost(
            masterServiceBaseUrl +
              "/floorMaster/updateFloorMaster/" +
              _tempArray[index].id,
            (data) => {
              successToast(data["message"]);
              setisSaveVisible(false);
              // delete _tempArray[index]['editMode']
              // props.setclassArray(_tempArray)
              props.fetchClasses(
                `${masterServiceBaseUrl}/floorMaster/getFloorMasterByBuildingMasterId/${buildingMasterId}`
              );
              settableDataKey(new Date().getMilliseconds());
              // props.fetchClasses(masterServiceBaseUrl + '/class/getAllClass')
            },
            (data) => {
              failureToast(data["message"]);
            },
            _tempArray[index],
            "put"
          );
        }
      } else {
      }
    });
  };
  const newRow = () => {
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes");
    } else {
      let cb = () => {
        addNewClass();
        setisSaveVisible(true);
        // settableDataKey(new Date().getMilliseconds())
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      props.setclassArray(_tempArray);
      setisSaveVisible(false);
      cb();
    }
  };
  const editRow = (index) => {
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes");
    } else {
      let cb = () => {
        var _tempArray = props.classArray;
        _tempArray[index]["editMode"] = true;
        props.setclassArray(_tempArray);
        setisSaveVisible(true);
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      cb();
    }
  };
  const deleteRow = (index) => {
    if (props.classArray[index]["__status"] == "__new") {
      let n = props.classArray;
      n.splice(index, 1);
      props.setclassArray(n);
      setisSaveVisible(false);
      settableDataKey(new Date().getMilliseconds());
    } else {
      if (window.confirm("Are you sure you want to delete this Floor?")) {
        putpost2(
          masterServiceBaseUrl +
            "/floorMaster/deleteFloorMaster/" +
            props.classArray[index].id,
          (data) => {
            successToast(data["message"]);
            props.fetchClasses(
              `${masterServiceBaseUrl}/floorMaster/getFloorMasterByBuildingMasterId/${buildingMasterId}`
            );
          },
          (data) => {
            failureToast(data["message"]);
          },
          "PUT"
        );
      }
    }
  };

  const updateKey = (index, value, key) => {
    var _tempArray = props.classArray;
    _tempArray[index][key] = value;
    props.setclassArray(_tempArray);
    setUpdateKey(new Date());
  };

  const setHeaderVal = (data) => {
    setHeaderDataForRoom({
      "Floor Name": data.floorName,
      "Floor Code": data.floorCode,
      "Floor Status": data.status,
    });
    props.history.push(`/admin/floor/${buildingMasterId}/rooms/${data.id}`);
  };

  const dataForExcel = props.serverData?.map((item) => {
    return { ...item, ...buildingHeraderData };
  });

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3 className="mb-0 ">Floor</h3>
                <div>
                  {!isSaveVisible && props.classArray.length ? (
                    <ToExcel
                      data={dataForExcel}
                      detailObj={excelDetails}
                      name="Floor"
                      isSaveVisible={isSaveVisible}
                    />
                  ) : null}
                  {checkPermission(userPermissions, 'C') && <Button
                    disabled={isSaveVisible || isDisabled}
                    color="info"
                    size="sm"
                    type="button"
                    className={
                      "floatRight" +
                      (isSaveVisible || isDisabled ? " btn-dark" : null)
                    }
                    onClick={() => {
                      newRow();
                    }}
                    data-testid="addNewFloor"
                  >
                    New Floor
                  </Button>}
                </div>
              </CardHeader>
              <div id="questionTable" className="table-responsive">
                <Table className="align-items-center table-flush ">
                  <MasterHeaderAuto headerList={headerList} />
                  <tbody className="list" key={tableDataKey}>
                    {props.classArray
                      ? props.classArray.map((el, index) =>
                          !el["editMode"] ? (
                            //
                            <>
                              <NewRow data={el} listToBeRendered={listToRender}>
                                <td className="text-center  white-breakSpace">
                                  <Button
                                    color="info"
                                    size="sm"
                                    type="button"
                                    // disabled={props.isViewOnly}
                                    onClick={() => setHeaderVal(el)}
                                    // data-testid="editButton"
                                  >
                                    Add/View Room
                                  </Button>
                                </td>
                                <td className="text-center  white-breakSpace">
                                  {checkPermission(userPermissions, 'U') && <Button
                                    color="info"
                                    size="sm"
                                    type="button"
                                    disabled={props.isViewOnly}
                                    onClick={() => editRow(index)}
                                    // data-testid="editButton"
                                  >
                                    <i className="fas fa-edit" />
                                  </Button>}
                                  {checkPermission(userPermissions, 'D') && <Button
                                    color="info"
                                    size="sm"
                                    type="button"
                                    disabled={props.isViewOnly}
                                    onClick={() => deleteRow(index)}
                                    // data-testid="deletebtn"
                                  >
                                    <i className="fas fa-trash" />
                                  </Button>}
                                </td>
                              </NewRow>
                            </>
                          ) : (
                            <tr key={index + "-class"}>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="floorName"
                                  defaultValue={el["floorName"]}
                                  placeholder="Floor Name"
                                  className="tdInput"
                                  maxLength="50"
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value.trim(),
                                      "floorName",
                                      true
                                    );
                                  }}
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  maxLength="50"
                                  defaultValue={el["floorCode"]}
                                  data-testid="floorCode"
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value.trim(),
                                      "floorCode",
                                      true
                                    );
                                  }}
                                  placeholder="Floor Code"
                                  className="tdInput"
                                />
                              </td>

                              <td className="text-center p-2 mx-1">
                                {/* <label className="custom-toggle mx-auto ml-2">
                                  <input
                                    checked={
                                      el.status == "ACTIVE" ? true : false
                                    }
                                    type="checkbox"
                                    id={el.id}
                                    onChange={(e) => {
                                      settableDataKey(
                                        new Date().getMilliseconds()
                                      );
                                      console.log(e.target.checked);
                                      let n = "ACTIVE";
                                      if (!e.target.checked) {
                                        n = "INACTIVE";
                                      }
                                      updateKey(index, n, "status");
                                    }}
                                    data-testid="floorStatus"
                                  />
                                  <span
                                    style={{ width: "72px" }}
                                    className="custom-toggle-slider rounded-circle activeToggle"
                                    data-label-off="Inactive"
                                    data-label-on="Active"
                                  />
                                </label> */}
                                <StatusCellComponent el={el} index={index} updateKey={updateKey} settableDataKey={settableDataKey} tableType="floor" />
                              </td>
                              <td className="text-center  white-breakSpace">
                                <Button
                                  color="secondary"
                                  size="sm"
                                  type="button"
                                  disabled
                                  onClick={() => setHeaderVal(el)}
                                  // data-testid="editButton"
                                >
                                  Add/View Room
                                </Button>
                              </td>
                              <td
                                className="text-center"
                                data-testid="saveConcessionFloor"
                              >
                                {" "}
                                <Button
                                  color="info"
                                  size="sm"
                                  type="button"
                                  className="mx-1"
                                  onClick={() => {
                                    saveAll();
                                  }}
                                >
                                  Save
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  type="button"
                                  onClick={() => {
                                    let n = props.classArray;
                                    if (n[index]["__status"] == "__new") {
                                      n.splice(index, 1);
                                    } else {
                                      // n[index]['editMode'] = false
                                      props.fetchClasses(
                                        `${masterServiceBaseUrl}/floorMaster/getFloorMasterByBuildingMasterId/${buildingMasterId}`
                                      );
                                    }
                                    props.setclassArray(n);
                                    setisSaveVisible(false);
                                  }}
                                >
                                  {" "}
                                  <i className="fas fa-times" />
                                </Button>{" "}
                              </td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </Table>
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default withRouter(FloorTable);
